<template>
  <div class="back-in-stock">
    <overlay
      key="backInStock"
      direction="left"
      namespace="backInStock"
      type="modal"
      block-class="back-in-stock-modal"
      @close="cleanModalState"
    >
      <template #close>
        <icon-close />
      </template>

      <template #body>
        <h3
          class="back-in-stock__header h4"
          v-text="$string('product.back_in_stock.title')"
        />

        <form @submit.prevent="submit">
          <label
            class="back-in-stock__label"
            for="email"
            v-text="$string('product.back_in_stock.email')"
          />

          <input
            ref="email"
            type="email"
            name="email"
            :placeholder="$string('product.back_in_stock.email')"
            required
          >
          <span
            v-if="success === true"
            class="caption success"
            v-text="$string('product.back_in_stock.success')"
          />
          <span
            v-if="success === false"
            class="caption error"
            v-html="error"
          />

          <btn
            class="back-in-stock__button"
            :label="$string('product.back_in_stock.notify_me')"
            modifiers="boxed block center"
            :show-icon="false"
            type="submit"
            :show-state-icon="state === 'processing'"
          >
            <template #stateIcon>
              <icon-loading />
            </template>
          </btn>
        </form>
      </template>
    </overlay>
  </div>
</template>

<script>

/**
 * Vue: Back in stock (back-in-stock)
 * -----------------------------------------------------------------------------
 * Back in Stock interface for the PDP.
 * @param {Object} liquid
 * @param {Object} variant
 */
import { mapActions, mapGetters } from 'vuex'
import Btn from '~global/btn/btn'
import Overlay from '~global/overlay/overlay'
import IconClose from '~icons/misc/close.svg'
import IconLoading from '~icons/misc/loading.svg'

export default {
  name: 'BackInStock',

  components: {
    Btn,
    Overlay,
    IconClose,
    IconLoading,
  },

  props: {
    variantId: {
      type: [String, Number],
      default: '',
      required: true,
    },
    productId: {
      type: [String, Number],
      default: '',
      required: true,
    },
  },

  data() {
    return {
      state: 'ready',
      error: '',
      success: null,
    }
  },

  methods: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getActiveOverlay: 'overlays/getActiveOverlay',
    }),

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Open Modal.
     */
    openModal() {
      this.toggleOverlay({
        ignoreDismissed: true,
        namespace: 'backInStock',
      })
    },

    /**
     * Clean Modal State:
     *  - set state to 'ready'.
     *  - clear error.
     *  - clear success flag.
     */
    cleanModalState() {
      this.state = 'ready'
      this.error = ''
      this.success = null
    },

    /**
     * Handle BIS form submission.
     */
    submit() {
      this.state = 'processing'

      const shopifyDomain = `${cnvs.credentials.storefront.store}.myshopify.com`
      const email = this.$refs.email.value

      fetch(`https://app.backinstock.org/stock_notification/create.json?shop=${shopifyDomain}&notification[email]=${email}&notification[product_no]=${this.productId}&notification[quantity_required]=1&notification[accepts_marketing]=true&variant[variant_no]=${this.variantId}`)
        .then((response) => {
          if (response.ok) {
            return response.json()
          }

          throw new Error(this.$string('product.back_in_stock.error'))
        })
        .then(({ errors, status }) => {
          if (status !== 'Error') {
            this.success = true
            this.state = 'ready'
            return
          }

          let errorMsg = ''

          for (const errorType in errors) {
            const errorLine = Array.isArray(errors[errorType])
              ? errors[errorType].join()
              : errors[errorType]

            errorMsg += `${errorLine} <br />`
          }

          throw new Error(errorMsg)
        })
        .catch((error) => {
          this.success = false
          this.error = error.message
          this.state = 'ready'
        })
    },
  },
}
</script>

<style lang="scss">
@import "./back-in-stock";
</style>
